import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgPourEventsIcon = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 20,
	height: 21,
	viewBox: "0 0 20 21",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		d: "M9.99996 18.8288C14.6023 18.8288 18.3333 15.0978 18.3333 10.4954C18.3333 5.89305 14.6023 2.16209 9.99996 2.16209C5.39759 2.16209 1.66663 5.89305 1.66663 10.4954C1.66663 15.0978 5.39759 18.8288 9.99996 18.8288Z",
		stroke: "currentColor",
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	}), /* @__PURE__ */ _jsx("path", {
		d: "M10 5.49542V10.4954L13.3333 12.1621",
		stroke: "currentColor",
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})]
});
export default SvgPourEventsIcon;
